import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  contentLoading: {
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    alignItems: 'center',
    fontSize: '18px',
  },
})
